<!-- eslint-disable prettier/prettier -->
<template>
  <section class="quotewizard">
    <loader :loading="loading"></loader>
    <div class="container">
      <div class="quoteleft">
        <div class="title">Renters Insurance</div>
        <br />
        <div class="poweredby-hotspot">
          <span class="poweredby">Provided by Assurant</span>
          <p class="poweredby-content">
            In all states, unless otherwise noted, Renters Insurance is
            underwritten by American Bankers Insurance Company of Florida with
            its home office in Miami, Florida. In Minnesota, the underwriter is
            American Security Insurance company. In Georgia, Residents Liability
            is underwritten by Voyager Indemnity Insurance Company. In Utah,
            coverage is provided under policy form AJ8850PC-0307 or
            AJ9281CKK-0609. The trade name Assurant is used to associate their
            products and services, and to connect with the brand of their parent
            company, Assurant, Inc.
          </p>
        </div>
        <br /><br /><br />
        <status-component />
        <div class="subtitle">
          Property Damage &amp; Personal Liability
          <help-popup
            msg="Covers damages to your college dorm, landlord's apartment, or your neighbor's 
            property - like from a resident-caused fire or water damage. In NC, 
            water damage liability protection is optional for Renters Insurance.
            Will also cover medical and legal expenses if someone gets hurt."
          />
        </div>
        <br />
        <!----->
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="policyoptionstable"
        >
          <tbody>
            <tr>
              <td width="30%">
                <strong class="subsubtitle">Coverage</strong>
                <red v-pre>*</red>
                <help-popup
                  msg="The maximum payout per claim."
                  help-class="help smallhelp"
                />
              </td>
              <td align="right">
                <template
                  v-for="liability in quote.info.quoteCoverageCue
                    .personalLiabilityOptions"
                >
                  <input
                    :id="'liability-coverage-limit-' + liability / 1000"
                    v-model="
                      quote.rentersInsurance.quoteCoverageDetails
                        .liabilityAmount
                    "
                    type="radio"
                    class="styledradio"
                    name="liabilityAmount"
                    :value="liability"
                    @change="rentersQuoteChange"
                  />
                  <label
                    :for="'liability-coverage-limit-' + liability / 1000"
                    style="margin-left: 5px !important"
                    >{{ formatAmountWithoutCent(liability) }}</label
                  >
                </template>
                <validation-error name="liabilityAmount" :errors="validationErrors" />
              </td>
            </tr>
          </tbody>
        </table>
        <!----->
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="policyoptionstable"
        >
          <tbody>
            <tr>
              <td width="30%">
                <strong class="subsubtitle">Deductible</strong>
                <red v-pre>*</red>
                <help-popup
                  msg="A deductible is the amount the policyholder must pay before the insurer pays out
                                        the claim."
                  help-class="help smallhelp"
                />
              </td>
              <td align="right">
                <div
                  v-for="deductible in quote.info.quoteCoverageCue
                    .deductibleOptions"
                  :key="deductible"
                  style="display: inline-block"
                >
                  <input
                    :id="'liability-ded-' + deductible"
                    v-model="
                      quote.rentersInsurance.quoteCoverageDetails.deductible
                    "
                    type="radio"
                    class="styledradio"
                    name="liability-ded"
                    :value="deductible"
                    @change="rentersQuoteChange"
                  />
                  <label
                    :for="'liability-ded-' + deductible"
                    style="margin-left: 5px !important"
                    >{{ formatAmountWithoutCent(deductible) }}
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!----->
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="policyoptionstable"
        >
          <tbody>
            <tr>
              <td width="30%">
                <strong class="subsubtitle">Payment Options</strong>
                <red v-pre>*</red>
                <help-popup
                  msg="Choose a payment plan that's best for you: monthly, 4-pay (payments 60 days
                                        apart), or annual."
                  help-class="help smallhelp"
                />
              </td>
              <td align="right">
                <input
                  id="liab-paymentplan-monthly"
                  v-model="quote.rentersInsurance.paymentOption"
                  type="radio"
                  class="styledradio"
                  name="liabilityPaymentPlan"
                  value="1"
                  @change="rentersQuoteChange"
                />
                <label
                  name="liabilityPaymentPlan"
                  for="liab-paymentplan-monthly"
                  :class="{
                    validationfield: hasErrors('liabilityPaymentPlan'),
                  }"
                  style="margin-left: 5px !important"
                  @click="validatedFieldChanged"
                  >Monthly
                </label>
                <input
                  id="liab-paymentplan-monthly-4-Pay"
                  v-model="quote.rentersInsurance.paymentOption"
                  type="radio"
                  class="styledradio"
                  name="liabilityPaymentPlan"
                  value="3"
                  @change="rentersQuoteChange"
                />
                <label
                  name="liabilityPaymentPlan"
                  for="liab-paymentplan-monthly-4-Pay"
                  :class="{
                    validationfield: hasErrors('liabilityPaymentPlan'),
                  }"
                  style="margin-left: 5px !important"
                  @click="validatedFieldChanged"
                  >4-Pay
                </label>
                <input
                  id="liab-paymentplan-monthly-annual"
                  v-model="quote.rentersInsurance.paymentOption"
                  type="radio"
                  class="styledradio"
                  name="liabilityPaymentPlan"
                  value="2"
                  @change="rentersQuoteChange"
                />
                <label
                  name="liabilityPaymentPlan"
                  for="liab-paymentplan-monthly-annual"
                  :class="{
                    validationfield: hasErrors('liabilityPaymentPlan'),
                  }"
                  style="margin-left: 5px !important"
                  @click="validatedFieldChanged"
                  >Annual
                </label>
                <validation-error name="liabilityPaymentPlan" :errors="validationErrors" />
              </td>
            </tr>
          </tbody>
        </table>
        <!----->
        <br /><br /><br />
        <span for="addpp" class="subtitle" style="color: #414142"
          >Personal Property Coverage
        </span>
        <help-popup
          msg="Covers the stuff you own -- from covered incidents like fire, lightning, and theft."
        />
        <br />
        <br />
        <!----->
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="policyoptionstable"
        >
          <tbody>
            <tr>
              <td width="30%">
                <strong class="subsubtitle">Coverage</strong> <red>*</red>
                <help-popup
                  msg="The maximum payout per claim."
                  help-class="help smallhelp"
                />
              </td>
              <td align="right">
                <select
                  v-model="
                    quote.rentersInsurance.quoteCoverageDetails
                      .personalPropertyAmount
                  "
                  style="width: 60%"
                  name="personalPropertyAmount"
                  :class="{
                    validationfield: hasErrors('personalPropertyAmount'),
                  }"
                  @change="rentersQuoteChange"
                >
                  <option value="0">Please Select...</option>
                  <option
                    v-for="item in personalPropertyCoverageItems"
                    :key="item"
                    :value="item"
                  >
                    {{ formatAmountWithoutCent(item) }}
                  </option>
                </select>
                <validation-error
                  name="personalPropertyAmount"
                  :errors="validationErrors"
                ></validation-error>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="spacer"></div>
        <div class="subtitle">Additional Protection</div>
        <br />
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="additional-table"
        >
          <tbody>
            <tr v-if="quote.info.quoteCoverageCue.hasReplacementCost == 'Y'">
              <!------------->
              <td style="width: 75%" valign="top">
                <span
                  id="replacementcost"
                  onclick="document.getElementById('replacementcost-content').classList.toggle('show');document.getElementById('replacementcost').classList.toggle('checked');"
                  >Replacement Cost</span
                >
                <div
                  id="replacementcost-content"
                  class="additional-content"
                  style="display: none"
                >
                  Coverage includes reimbursement for the actual cost of
                  replacing belongings.
                </div>
              </td>
              <td valign="top">
                <div class="additional-included">Included</div>
              </td>
            </tr>
            <!------------->
            <tr v-if="quote.info.quoteCoverageCue.hasWaterBackup == 'Y'">
              <td valign="top">
                <span
                  id="watersewerbackup"
                  onclick="document.getElementById('watersewerbackup-content').classList.toggle('show');document.getElementById('watersewerbackup').classList.toggle('checked');"
                  >Water Sewer Backup</span
                >
                <div
                  id="watersewerbackup-content"
                  class="additional-content"
                  style="display: none"
                >
                  Coverage includes up to {{ waterSewerCoverage }} in damages if
                  a sewer or drain backs up into your home. A $250 deductible
                  applies.
                </div>
              </td>
              <td valign="top">
                <input
                  id="3"
                  v-model="
                    quote.rentersInsurance.quoteCoverageDetails.waterBackup
                  "
                  name=""
                  class="additional-add"
                  checked: any
                  type="checkbox"
                  @change="rentersQuoteChange"
                />
                <label for="3"></label>
              </td>
            </tr>
            <!------------->
            <tr v-if="quote.info.quoteCoverageCue.hasIdFraud == 'Y'">
              <td valign="top">
                <span
                  id="fraudexpense"
                  onclick="document.getElementById('fraudexpense-content').classList.toggle('show');document.getElementById('fraudexpense').classList.toggle('checked');"
                  >Fraud Expense Protection</span
                >
                <div
                  id="fraudexpense-content"
                  class="additional-content"
                  style="display: none"
                >
                  Identity fraud expense coverage includes up to $15,000 for
                  your expenses as a result of being a victim of identity fraud.
                  A $100 deductible applies.
                </div>
              </td>
              <td valign="top">
                <input
                  id="4"
                  v-model="
                    quote.rentersInsurance.quoteCoverageDetails.identityFraud
                  "
                  name=""
                  class="additional-add"
                  type="checkbox"
                  @change="rentersQuoteChange"
                /><label for="4"></label>
              </td>
            </tr>
            <!------------->
            <tr v-if="quote.info.quoteCoverageCue.hasEarthquake == 'Y'">
              <td valign="top">
                <span
                  id="earthquake"
                  onclick="document.getElementById('earthquale-content').classList.toggle('show');document.getElementById('earthquake').classList.toggle('checked');"
                  >Earthquake</span
                >
                <div
                  id="earthquale-content"
                  class="additional-content"
                  style="display: none"
                >
                  Coverage includes up to the amount you chose for your
                  belongings and additional living expenses if you need to stay
                  somewhere else. A deductible applies.
                </div>
              </td>
              <td valign="top">
                <input
                  id="5"
                  v-model="
                    quote.rentersInsurance.quoteCoverageDetails.earthquake
                  "
                  name=""
                  class="additional-add"
                  type="checkbox"
                  @change="rentersQuoteChange"
                /><label for="5"></label>
              </td>
            </tr>
          </tbody>
        </table>
        <br /><br /><br /><br />
        <div style="text-align: center">
          <button
            :class="{ disabled: !validated }"
            @click="goToPage('quote-addon')"
          >
            Continue
          </button>
        </div>
        <br /><br /><br /><br /><br /><br />
      </div>
      <!--------------------------------------------------------------------------------------------->
      <quote-cart />
    </div>
  </section>
</template>

<script lang="ts" setup>
import QuoteCart from "@/views/quote/QuoteCart.vue";
import HelpPopup from "@/components/HelpPopup.vue";
import { formatAmountWithoutCents, scrollTop } from "@/utils/Utils";
import Loader from "@/components/MainLoader.vue";
import StatusComponent from "@/components/StatusComponent.vue";
import { AssurantData } from "@/api/AssurantData";
import ValidationError from "@/components/ValidationError.vue";
import { inject } from "vue";
import { ref, computed, Ref, ComputedRef } from "@vue/reactivity";
import { useQuoteStore } from "@/stores/root/quote";
import { scrollMeTo, stat } from "@/utils/Utils";
import { useStatusStore } from "@/stores/root/status";

const props = defineProps({
  anchor: {
    type: String,
    default: "",
  },
});

const title = "Quote";
//anchor!: string;
const loading: Ref<boolean> = ref(false);
const validationErrors: Ref<any[]> = ref([]);
const emit = defineEmits(["quote-changed"]);
const inj = inject("$emitter");
const statusStore = useStatusStore();
const refName = ref(null);
const quote = useQuoteStore();

//function formatAmountWithoutCents(amount: number) {
function formatAmountWithoutCent(amount: number) {
  return formatAmountWithoutCents(amount);
}

//function formatAmount(amount: number) {  I dont see usage of this function
// function formatAmounts(amount: number) {
//   return formatAmount(amount);
// }

const validated = computed(() => {
  const rentersValidate =
    quote.rentersInsurance.quoteCoverageDetails.personalPropertyAmount > 0 &&
    quote.rentersInsurance.quoteCoverageDetails.liabilityAmount > 0 &&
    quote.rentersInsurance.quoteCoverageDetails.deductible &&
    quote.rentersInsurance.paymentOption &&
    quote.rentersInsurance.rentersApiOk;

  return rentersValidate;
});

function createValidationMessages(): void {
  validationErrors.value.length = 0;
  if (
    !(quote.rentersInsurance.quoteCoverageDetails.personalPropertyAmount > 0)
  ) {
    const error = {
      name: "personalPropertyAmount",
      value: "Coverage is required.",
    };
    validationErrors.value.push(error);
  }
  if (!(quote.rentersInsurance.quoteCoverageDetails.liabilityAmount > 0)) {
    const error = {
      name: "liabilityAmount",
      value: "Coverage is required.",
    };
    validationErrors.value.push(error);
  }
  if (!(quote.rentersInsurance.paymentOption > 0)) {
    const error = {
      name: "liabilityPaymentPlan",
      value: "Payment option is required.",
    };
    validationErrors.value.push(error);
  }
}

function goToPage(command: string) {
  if (!validated.value) {
    createValidationMessages();
    stat(statusStore).error("Please fill in required fields.");
    scrollMeTo("status");
    return;
  }
  quote.hasPersonalInsurance
    ? quote.setQuoteStep(command)
    : quote.setQuoteStep("quote-account");
}

const personalPropertyCoverageItems = computed(() => {
  const personalPrpCovItems = [];
  const min = Number(quote.info.quoteCoverageCue.personalPropertyMin);
  const max = Number(quote.info.quoteCoverageCue.personalPropertyMax);
  const incr = Number(quote.info.quoteCoverageCue.personalPropertyIncrement);
  if (max != 0) {
    for (let i = min; i <= max; i += incr) {
      personalPrpCovItems.push(i);
    }
  }
  return personalPrpCovItems;
});

function clearValidationMessage(name: string): void {
  const elements = validationErrors.value.filter((element) => {
    return element.name == name;
  });
  elements.forEach((element) => {
    const index = validationErrors.value.indexOf(element);
    validationErrors.value.splice(index, 1);
  });
  if (!validationErrors.value.length) {
    stat(statusStore).clear();
  }
}

function validatedFieldChanged(event: any): void {
  if (!event || !event.target || !event.target.name) {
    return;
  }
  clearValidationMessage(event.target.name);
}

const quoteChange = async (event: any) => {
  (inj as any).emit("quote-changed");
  validatedFieldChanged(event);
};

const rentersQuoteChange = async (event: any) => {
  if (
    quote.rentersInsurance.quoteCoverageDetails.liabilityAmount &&
    quote.rentersInsurance.quoteCoverageDetails.deductible
  ) {
    loading.value = true;
    stat(statusStore).clear();
    const quoteResult = await AssurantData.readAssurantData(quote, true);
    if (quoteResult.error) {
      loading.value = false;
      if (quoteResult.denialNotice !== "") {
        quote.saveDenialNotice(quoteResult.denialNotice);
        quote.saveResponseMessage(quoteResult.message);
        quote.setQuoteStep("quote-denied");
        return;
      }
      if (quoteResult.message == "Quoting Error") {
        alert("Quote unavailable. Please select another option.");
        quote.rentersInsurance.quoteCoverageDetails.deductible = 250;
        quote.rentersInsurance.paymentOption = 0;
        quote.rentersInsurance.dueToday = 0;
        return;
      }
      alert("Something went wrong.");
      quote.rentersInsurance.quoteCoverageDetails.deductible = 250;
      quote.rentersInsurance.paymentOption = 0;
      quote.rentersInsurance.dueToday = 0;
      scrollTop();
      stat(statusStore).error(quoteResult.message);
      //return;
    }
    loading.value = false;
  }
  quoteChange(event);
};

function hasErrors(name: string): boolean {
  return (
    validationErrors.value.find((element) => {
      return element.name == name;
    }) != null
  );
}

const waterSewerCoverage: ComputedRef<string> = computed(() => {
  if (quote.address.state.short == "NC") {
    return "$5,000";
  }
  if (quote.address.state.short == "MD") {
    return "the property coverage amount";
  }
  return "$2,500";
});
</script>
